'use strict';

// TODO: Refactor.
module.exports = function (app) {
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        if ('history' !== e.target.getAttribute('aria-controls')) {
            return;
        }

        $.ajax({
            url: '/order/order-history/list/' + window.app.values.order.id
        }).done(function(data) {
            $('#history').html(data);
        });
    });

    return app;
};
